import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENVIRONMENT } from '../../../../environment/environment';
import { ApiResponse } from '../../models/api-response.model';
import { AskpodAddonPlanList, AskpodCampaignList } from '../../models/askpod.model';

@Injectable({
    providedIn: 'root',
})
export class AskpodService {
    private apiRoute = `${ENVIRONMENT.apiDomain}/api/v1/askpod`;

    constructor(private httpClient: HttpClient) {}

    /**
     * Mints a short-lived SSO redirect URL into askPOD for the current user.
     * Returns 403 when the user's current plan is not askPOD-eligible — caller is
     * expected to disable the trigger UI on that response.
     */
    public getSsoLink(): Observable<ApiResponse<string>> {
        return this.httpClient.post<ApiResponse<string>>(`${this.apiRoute}/sso-link`, {});
    }

    /**
     * Get active askPOD campaigns
     */
    public getActiveCampaigns(): Observable<ApiResponse<AskpodCampaignList>> {
        return this.httpClient.get<ApiResponse<AskpodCampaignList>>(`${this.apiRoute}/campaigns`);
    }

    /**
     * Get the askPOD add-on plan catalogue. Used by the "Trial Has Ended" modal to
     * render the available packages (name, daily credits and price) instead of
     * hardcoding them.
     */
    public getAddonPlans(): Observable<ApiResponse<AskpodAddonPlanList>> {
        return this.httpClient.get<ApiResponse<AskpodAddonPlanList>>(`${this.apiRoute}/addon-plans`);
    }
}
